module.exports = __webpack_public_path__ + "img/logo.ba8090e.png";